/* eslint-disable import/prefer-default-export */
export const getNotifications = (state) => state.notifications.notifications;
